﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import './jquery';
import "jquery-mask-plugin";
import "jquery-validation"
import "jquery-validation-unobtrusive";
import "bootstrap";
import "sat";
import * as _ from 'lodash';
import Raphael, { RaphaelElement, RaphaelPaper } from 'raphael';
import * as SAT from 'sat';

export class SignatureWidget {
    private element: HTMLElement;
    private service: Service;
    private debug: boolean = true;
    private rectResultElement: { left?: number; top?: number; width?: number; height?: number };
    private pageResult: number = 1;
    private currentScale: number;
    private resultEntities;
    private signatureBoxWidth: number;
    private signatureBoxHeight: number;
    private completed: boolean;
    private raphaelCanvas;

    private currentMaxSignature: number = 1;
    private currentStepSignature: number = 1;

    private signeeCount: number;
    private WorldRaphael;
    private BoxWidth: number;
    private BoxHeight: number;
    private pdf: any;
    constructor(element: HTMLElement, boxWidth:number,boxHeight:number) {
        let th = this;
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        //let scale = window.devicePixelRatio;
        this.BoxWidth = boxWidth;
        this.BoxHeight = boxHeight ;
        this.signatureBoxWidth = boxWidth;
        this.signatureBoxHeight = boxHeight;
        th._debugging("signature box dimensions: w " + boxWidth + " h " + boxHeight);
    }
    setComplete() {
        this.completed = true;
    }
    isComplete() {
        return this.completed;
    }
    initOverlay(signeeCount:number) {
        try {
            let th = this;
            const image = document.getElementById('the-canvas') as HTMLCanvasElement;
            const canvas = document.getElementById('canvas') as HTMLCanvasElement;


            let dragTL = false;
            let dragBL = false;
            let dragTR = false;
            let dragBR = false;
            let dragWholeRect = false;

            const rect: { left?: number; top?: number; width?: number; height?: number } = {};
            const current_canvas_rect: { width?: number; height?: number; top?: number; left?: number } = {};

            let mouseX: number;
            let mouseY: number;
            let startX: number;
            let startY: number;

            const th_left = 504;
            const th_top = 0;
            const th_right = 3528;
            const th_bottom = 3024;

            const th_width = th_right - th_left;
            const th_height = th_bottom - th_top;

            const effective_image_width = 4032;
            const effective_image_height = 3024;



            function drawRectInCanvas() {
                const ctx = canvas.getContext('2d')!;
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.beginPath();
                ctx.lineWidth = 2;
                ctx.fillStyle = 'rgba(42, 90, 166, 0.2)';
                ctx.strokeStyle = '#000';
                ctx.rect(rect.left!, rect.top!, rect.width!, rect.height!);
                ctx.fill();
                ctx.stroke();
                th.rectResultElement = rect;
            }
            //drawRectInCanvas() connected functions -- END

            function mouseUp(e: MouseEvent) {
                dragTL = dragBL = dragTR = dragBR = false;
                dragWholeRect = false;
            }

            //mousedown connected functions -- START
            function checkInRect(x: number, y: number, r: { left?: number; top?: number; width?: number; height?: number }) {
                return x > r.left! && x < r.width! + r.left! && y > r.top! && y < r.top! + r.height!;
            }

            function getMousePos(canvas: HTMLCanvasElement, evt: MouseEvent | TouchEvent) {
                let clx: number, cly: number;
                if (evt.type === 'touchstart' || evt.type === 'touchmove') {
                    clx = (evt as TouchEvent).touches[0].clientX;
                    cly = (evt as TouchEvent).touches[0].clientY;
                } else {
                    clx = (evt as MouseEvent).clientX;
                    cly = (evt as MouseEvent).clientY;
                }
                const boundingRect = canvas.getBoundingClientRect();
                return {
                    x: clx - boundingRect.left,
                    y: cly - boundingRect.top,
                };
            }

            function mouseDown(this: HTMLCanvasElement, e: MouseEvent | TouchEvent) {
                const pos = getMousePos(this, e);
                mouseX = pos.x;
                mouseY = pos.y;
                if (checkInRect(mouseX, mouseY, rect)) {
                    dragWholeRect = true;
                    startX = mouseX;
                    startY = mouseY;
                }
                drawRectInCanvas();
            }
            //mousedown connected functions -- END

            function mouseMove(this: HTMLCanvasElement, e: MouseEvent | TouchEvent) {
                const pos = getMousePos(this, e);
                mouseX = pos.x;
                mouseY = pos.y;
                if (dragWholeRect) {
                    e.preventDefault();
                    e.stopPropagation();
                    const dx = mouseX - startX;
                    const dy = mouseY - startY;
                    if (rect.left! + dx > 0 && rect.left! + dx + rect.width! < canvas.width) {
                        rect.left! += dx;
                    }
                    if (rect.top! + dy > 0 && rect.top! + dy + rect.height! < canvas.height) {
                        rect.top! += dy;
                    }
                    startX = mouseX;
                    startY = mouseY;
                }
                drawRectInCanvas();
            }

            function updateCurrentCanvasRect() {
                current_canvas_rect.height = canvas.clientHeight;
                current_canvas_rect.width = canvas.clientWidth;
                current_canvas_rect.top = image.offsetTop;
                current_canvas_rect.left = image.offsetLeft;
            }

            function repositionCanvas() {
                //make canvas same as image, which may have changed size and position
                canvas.height = image.height;
                canvas.width = image.width;
                canvas.style.top = image.offsetTop + 'px';
                canvas.style.left = image.offsetLeft + 'px';
                //compute ratio comparing the NEW canvas rect with the OLD (current)
                const ratio_w = canvas.width / current_canvas_rect.width!;
                const ratio_h = canvas.height / current_canvas_rect.height!;
                //update rect coordinates
                rect.top! = rect.top! * ratio_h;
                rect.left! = rect.left! * ratio_w;
                rect.height! = rect.height! * ratio_h;
                rect.width! = rect.width! * ratio_w;
                updateCurrentCanvasRect();
                drawRectInCanvas();
            }

            function initCanvas() {
                canvas.height = image.clientHeight;
                canvas.width = image.clientWidth;
                canvas.style.top = image.offsetTop + 'px';
                canvas.style.left = image.offsetLeft + 'px';
                updateCurrentCanvasRect();
            }

            function initRect() {
                //BORDER OF SIZE 2!
                rect.height = 30;
                rect.width = 200;
                rect.top = canvas.height - rect.height - 2;
                rect.left = canvas.width - rect.width - 2;
            }

            function init() {
                canvas.addEventListener('mousedown', mouseDown);
                canvas.addEventListener('mouseup', mouseUp);
                canvas.addEventListener('mousemove', mouseMove);
                canvas.addEventListener('touchstart', mouseDown);
                canvas.addEventListener('touchmove', mouseMove);
                canvas.addEventListener('touchend', mouseUp);
                initCanvas();
                initRect();
                drawRectInCanvas();
            }
            this._debugging("init");
            init();
            window.addEventListener('resize', repositionCanvas);
        } catch (e) {
            console.log(e);
        }
    }

    initPdf(pdf: any, signeeCount: number) {
        try {
            let th = this;
            th.pdf = pdf;
            th.signeeCount = signeeCount;
            const colors = ["rgba(116, 163, 226, 0.49)", "rgba(112, 112, 112, 1)"];
            $(function () {
                try {
                    let self = this;
                    var V = function (x, y) { return new SAT.Vector(x, y); };
                    var P = function (pos, points) { return new SAT.Polygon(pos, points); };
                    var C = function (pos, r) { return new SAT.Circle(pos, r); };
                    var B = function (pos, w, h) { return new SAT.Box(pos, w, h); };

                    function poly2path(polygon) {
                        var pos = polygon.pos;
                        var points = polygon.calcPoints;
                        var result = 'M' + pos.x + ' ' + pos.y;
                        result += 'M' + (pos.x + points[0].x) + ' ' + (pos.y + points[0].y);
                        for (var i = 1; i < points.length; i++) {
                            var point = points[i];
                            result += 'L' + (pos.x + point.x) + ' ' + (pos.y + point.y);
                        }
                        result += 'Z';
                        return result;
                    }

                    function startDrag(entity) {
                        return function () {
                            this.ox = entity.data.pos.x;
                            this.oy = entity.data.pos.y;
                        };
                    }
                    function moveDrag(entity, world) {
                        return function (dx, dy) {
                            //entity.data.pos.x = this.ox + dx;
                            //entity.data.pos.y = this.oy + dy;
                            entity.data.pos.x = Math.min(th.raphaelCanvas.width - th.signatureBoxWidth, Math.max(0, this.ox + dx));
                            entity.data.pos.y = Math.min(th.raphaelCanvas.height - th.signatureBoxHeight, Math.max(0, this.oy + dy));
                            world.simulate();
                        };
                    }
                    function endDrag(entity) {
                        return function () {
                            entity.updateDisplay();
                        };
                    }

                    var idCounter = 0;

                    function noop() { }

                    function Entity(data, display, options) {
                        options = _.defaults(options || {}, {
                            solid: false,
                            heavy: false,
                            displayAttrs: {},
                            onCollide: noop,
                            onTick: noop
                        });
                        this.id = idCounter++;
                        this.data = data;
                        this.display = display;
                        this.displayAttrs = _.extend({
                            fill: colors[0],
                            stroke: 'rgba(0,0,0,0)'
                        }, options.displayAttrs);
                        this.isSolid = options.solid;
                        this.isHeavy = options.heavy;
                        this.onCollide = options.onCollide;
                        this.onTick = options.onTick;
                        this.page = 0;
                        this.dragStore=null;
                    }
                    Entity.prototype = {
                        remove: function () {
                            this.display.remove();
                        },
                        updateDisplay: function () {
                            if (this.data instanceof SAT.Circle) {
                                this.displayAttrs.cx = this.data.pos.x;
                                this.displayAttrs.cy = this.data.pos.y;
                                this.displayAttrs.r = this.data.r;
                            } else {
                                this.displayAttrs.path = poly2path(this.data);
                            }
                            this.display.attr(this.displayAttrs);
                        },
                        tick: function () {
                            this.onTick();
                        },
                        hide: function () {
                            this.displayAttrs.fill = 'rgba(0,0,0,0)';
                            this.updateDisplay();
                            this.text.remove();
                        },
                        show: function () {
                            if (this.isHeavy) {
                                this.displayAttrs.fill = colors[1];
                                this.text = th.raphaelCanvas.text(this.data.pos.x + (th.signatureBoxWidth / 2), this.data.pos.y + (th.signatureBoxHeight / 2), this.id + 1).attr({ fill: 'blue', 'font-size': 30 })
                            }
                            else this.displayAttrs.fill = colors[0];
                            this.updateDisplay();
                        },
                        unlock: function () {
                            this.page = th.pageResult;
                            this.data.draggable = true;                             
                            this.isHeavy = false;
                            this.displayAttrs.fill = colors[0];
                            this.text.remove();
                        },
                        respondToCollision: function (other, response) {
                            this.onCollide(other, response);
                            if (this.isSolid && other.isSolid &&
                                !(this.isHeavy && other.isHeavy)) {
                                if (this.isHeavy) {
                                    other.data.pos.add(response.overlapV);
                                } else if (other.isHeavy) {
                                    this.data.pos.sub(response.overlapV);
                                } else {
                                    response.overlapV.scale(0.5);
                                    this.data.pos.sub(response.overlapV);
                                    other.data.pos.add(response.overlapV);
                                }
                            }
                        },
                        resize: function () {
                            //this.data = P(V(120, (60)), [V(0, 0), V(th.signatureBoxWidth, 0), V(th.signatureBoxWidth, th.signatureBoxHeight), V(0, th.signatureBoxHeight)])
                        }
                    };

                    function World(canvas, options) {
                        options = _.defaults(options || {}, {
                            loopCount: 1
                        });
                        this.canvas = canvas;
                        this.response = new SAT.Response();
                        this.loopCount = options.loopCount;
                        this.entities = [];
                    }

                    World.prototype = {
                        addEntity: function (data, options) {
                            var entity = new Entity(
                                data,
                                data instanceof SAT.Circle ? this.canvas.circle() : this.canvas.path(),
                                options
                            );
                            if (options.draggable) {
                                entity.display.drag(moveDrag(entity, this), startDrag(entity), endDrag(entity));
                            }
                            entity.updateDisplay();
                            this.entities[entity.id] = entity;

                            return entity;
                        },
                        unlockEntity: function (entity) {
                            entity.unlock();                                 
                            entity.display._drag = entity.dragStore;                                
                            entity.updateDisplay();
                            return entity;
                        },
                        removeEntity: function (entity) {
                            if (entity.text != undefined) entity.text.remove();
                            entity.remove();
                            delete this.entities[entity.id];
                        },
                        reset: function () {
                            let selfW = this;
                            this.entities.forEach(function (e, i) {
                                selfW.removeEntity(e);
                            })                             
                            this.entities = [];
                            idCounter = 0;
                            this.addEntity(P(V(120, (60)), [V(0, 0), V(th.signatureBoxWidth, 0), V(th.signatureBoxWidth, th.signatureBoxHeight), V(0, th.signatureBoxHeight)]), { solid: true, draggable: true });
                            this.simulate();
                        },
                        simulate: function () {
                            var entities = _.values(this.entities);
                            var entitiesLen = entities.length;
                            th.resultEntities = entities;
                            _.each(entities, function (entity) {
                                entity.tick();
                            });
                            var loopCount = this.loopCount;
                            for (var i = 0; i < loopCount; i++) {
                                for (var aCount = 0; aCount < entitiesLen; aCount++) {
                                    var a = entities[aCount];
                                    for (var bCount = aCount + 1; bCount < entitiesLen; bCount++) {
                                        var b = entities[bCount];
                                        this.response.clear();
                                        var collided;
                                        var aData = a.data;
                                        var bData = b.data;
                                        if (aData instanceof SAT.Circle) {
                                            if (bData instanceof SAT.Circle) {
                                                collided = SAT.testCircleCircle(aData, bData, this.response);
                                            } else {
                                                collided = SAT.testCirclePolygon(aData, bData, this.response);
                                            }
                                        } else {
                                            if (bData instanceof SAT.Circle) {
                                                collided = SAT.testPolygonCircle(aData, bData, this.response);
                                            } else {
                                                collided = SAT.testPolygonPolygon(aData, bData, this.response);
                                            }
                                        }
                                        if (collided) {
                                            a.respondToCollision(b, this.response);
                                        }
                                    }
                                }
                            }
                            _.each(entities, function (entity) {
                                entity.updateDisplay();
                            });
                        },
                        adjustWorld: function (page) {
                            var entities = _.values(this.entities);
                            if (entities != null) {
                                entities.forEach(function (e, i) {
                                    if (e.page == page) {
                                        e.isSolid = true;
                                        e.show();
                                    }
                                    else {
                                        e.isSolid = false;
                                        e.hide();
                                    }
                                })
                            }
                        },
                        resize: function () {
                            var entities = _.values(this.entities);
                            if (entities != null) {
                                entities.forEach(function (e, i) {
                                    e.resize();
                                })
                            }
                        }
                    };
                    //modalc za izbiro pozicije podpisa
                    //zgoraj je koda za overlay
                    //spodaj je koda za nalaganje pdfja
                                        
                    //const wrapper = th.element.querySelector('.canvas-wrapper')[0] as HTMLElement;
                    const image = $(th.element).find('.the-canvas')[0] as HTMLCanvasElement;
                    $(th.element).find('.canvas-overlay').empty();
                    let container = $(th.element).find('.canvas-overlay')[0] as HTMLElement;
                    th.raphaelCanvas = Raphael(container, image.width, image.height);
                    th.WorldRaphael = new World(th.raphaelCanvas, null);
                    var reader = new FileReader();

                    //th.resetWorld = world.reset.bind(world);
                    //nov entity definiran z vektorji 
                    var currentEntity = th.WorldRaphael.addEntity(P(V(120, (60)), [V(0, 0), V(th.signatureBoxWidth, 0), V(th.signatureBoxWidth, th.signatureBoxHeight), V(0, th.signatureBoxHeight)]), { solid: true, draggable: true });
                    th.WorldRaphael.simulate();

                    function nextEntity(num) {
                        let i = num - 1;
                        if (th.WorldRaphael.entities[i] == null) {
                            currentEntity = th.WorldRaphael.addEntity(P(V(120, (60)), [V(0, 0), V(th.signatureBoxWidth, 0), V(th.signatureBoxWidth, th.signatureBoxHeight), V(0, th.signatureBoxHeight)]), { solid: true, draggable: true });
                        } else {
                            currentEntity = th.WorldRaphael.entities[i];
                            th.WorldRaphael.unlockEntity(currentEntity);
                        }
                        currentEntity.page = th.pageResult;
                        th.WorldRaphael.simulate();
                    }
                    function previousEntity(num) {
                        let i = num - 1;
                        currentEntity = th.WorldRaphael.entities[i];
                        th.WorldRaphael.unlockEntity(currentEntity);
                        th.WorldRaphael.simulate();
                    }

                    function adjustWorldSize(page) {
                        th.raphaelCanvas.setSize(image.width, image.height);
                        currentEntity.page = page;
                        th.WorldRaphael.adjustWorld(page);
                    }

                    function resizeEntities() {
                        let scale = th.currentScale;
                        th.signatureBoxWidth = th.BoxWidth * scale;
                        th.signatureBoxHeight = th.BoxHeight * scale;
                        th.WorldRaphael.resize(scale);
                    }

                    onresize = (event) => {
                        //resizeEntities()       //nenamerno resetira pozicije
                    };

                    reader.onload = function (e: any) {
                        th._debugging("reader on load");
                        if (th.signeeCount == null) {
                            //$(th.element).find('.add-signature').show();
                        }
                        else if (th.signeeCount > 1) {  //TODO
                            $(th.element).find('[data-id=next-signature]').show();
                            $(th.element).find('.confirmrect').hide();
                        }
                        $(th.element).find('.signature_num').html("1");
                        var arrayBuffer = e.target.result;
                        var typedarray = new Uint8Array(arrayBuffer);
                        var pdfjsLib = window['pdfjsLib'];

                        pdfjsLib.GlobalWorkerOptions.workerSrc = "/js/pdf.worker.mjs";                                         

                        var pdfDoc = null,
                            pageNum = 1,
                            pageRendering = false,
                            pageNumPending = null,
                            signatureNum = 1,
                            scale = th.currentScale = 1,
                            canvas = image,
                            ctx = canvas.getContext('2d');


                        function renderPage(num) {
                            try {
                                th._debugging("rendering page");
                                pageRendering = true;
                                pdfDoc.getPage(num).then(function (page) {
                                    let self = th;
                                    var unscaledViewport = page.getViewport({ scale: scale });
                                    self._debugging(unscaledViewport);
                                    while (unscaledViewport.width > window.innerWidth) {
                                        scale -= 0.1;
                                        th._debugging("scale: " + scale);
                                        unscaledViewport = page.getViewport({ scale: scale });
                                        th._debugging(unscaledViewport);
                                    }
                                    th._debugging("result:");
                                    th._debugging(scale);
                                    th.currentScale = scale;
                                    resizeEntities()

                                    //this.targetProxy.scale = scale;
                                    var viewport = page.getViewport({ scale: scale });
                                    canvas.height = viewport.height;
                                    canvas.width = viewport.width;

                                    var renderContext = {
                                        canvasContext: ctx,
                                        viewport: viewport
                                    };
                                    var renderTask = page.render(renderContext);

                                    renderTask.promise.then(function () {
                                        pageRendering = false;
                                        adjustWorldSize(num);

                                        if (pageNumPending !== null) {
                                            renderPage(pageNumPending);
                                            pageNumPending = null;
                                        }
                                    });
                                    
                                }).catch(function (e) {
                                    //$(th.element).find(".signature-modal").modal('hide');
                                });
                                
                                $(th.element).find('.page_num').text(num);
                            } catch (e) {
                                throw e
                            }
                        }

                        function queueRenderPage(num) {
                            if (pageRendering) {
                                pageNumPending = num;
                            } else {
                                renderPage(num);
                            }
                        }
                          //prev page
                        function onPrevPage() {
                            if (pageNum <= 1) {
                                return;
                            }
                            pageNum--;
                            queueRenderPage(pageNum);
                            th.pageResult = pageNum;
                        }
                        $(th.element).find('.prev').off("click");
                        $(th.element).find('.prev').on("click", function () { onPrevPage(); })
                        //next page
                        function onNextPage() {
                            if (pageNum >= pdfDoc.numPages) {
                                return;
                            }
                            pageNum++;
                            queueRenderPage(pageNum);
                            th.pageResult = pageNum;
                        }
                        $(th.element).find('.next').off("click");
                        $(th.element).find('.next').on("click", function () { onNextPage(); })
                        //first page
                        function onFirstPage() {
                            if (1 == pdfDoc.numPages) {
                                return;
                            }
                            pageNum=1;
                            queueRenderPage(pageNum);
                            th.pageResult = pageNum;
                        }
                        $(th.element).find('.first').off("click");
                        $(th.element).find('.first').on("click", function () { onFirstPage(); })
                        //last page
                        function onLastPage() {
                            if (pageNum >= pdfDoc.numPages) {
                                return;
                            }
                            pageNum = pdfDoc.numPages;
                            queueRenderPage(pageNum);
                            th.pageResult = pageNum;
                        }
                        $(th.element).find('.last').off("click");
                        $(th.element).find('.last').on("click", function () { onLastPage(); })

                        pdfjsLib.getDocument(typedarray).promise.then(function (pdfDoc_) {
                            pdfDoc = pdfDoc_;
                            $(th.element).find('.page_count').html(pdfDoc.numPages);
                            if (pdfDoc.numPages < 2) $(th.element).find(".pages-component").hide();
                            else $(th.element).find(".pages-component").show();
                            if (th.signeeCount == null)
                                $(th.element).find('.signature_count').html("1");
                            else
                                $(th.element).find('.signature_count').html(th.signeeCount.toString());    //TODO
                            renderPage(pageNum);

                        });
                          //naslednji
                        function onNextSignature() {
                            signatureNum++;
                            if (th.currentMaxSignature < signatureNum) th.currentMaxSignature++;
                            th.currentStepSignature = signatureNum;
                            if (signatureNum >= th.signeeCount) {
                                //$(th.element).find('.add-signature').hide();
                                $(th.element).find('[data-id=next-signature]').hide();
                                $(th.element).find('.confirmrect').show();
                            }
                            if (signatureNum != 1 && th.signeeCount > 1) {
                                $(th.element).find('[data-id=previous-signature]').show();
                            }
                            currentEntity.data.draggable = false;
                            currentEntity.dragStore = currentEntity.display._drag;
                            //currentEntity.display.drag = null;
                            currentEntity.display._drag = null;
                            currentEntity.isHeavy = true;
                            currentEntity.page = th.pageResult;
                            currentEntity.show();
                            currentEntity.updateDisplay();
                            $(th.element).find('.signature_num').html(signatureNum.toString());
                            nextEntity(signatureNum);
                        }
                        //prejšnji
                        function onPreviousSignature() {

                            signatureNum--;
                            th.currentStepSignature = signatureNum;

                            if (signatureNum < th.signeeCount) {
                                //$(th.element).find('.add-signature').hide();
                                $(th.element).find('[data-id=next-signature]').show();
                                $(th.element).find('.confirmrect').hide();
                            }
                            if (signatureNum == 1) {
                                $(th.element).find('[data-id=previous-signature]').hide();
                            }
                            currentEntity.data.draggable = false;
                            currentEntity.dragStore = currentEntity.display._drag;
                            //currentEntity.display.drag = null;
                            currentEntity.display._drag = null;
                            currentEntity.isHeavy = true;
                            currentEntity.page = th.pageResult;
                            currentEntity.show();
                            currentEntity.updateDisplay();
                            $(th.element).find('.signature_num').html(signatureNum.toString());
                            previousEntity(signatureNum);
                        }
                        //to je blo mišljen da boš lahko na dokumentu šele izbiru kolk podpisnikov bo
                        function onAddSignature() {
                            signatureNum++
                            currentEntity.data.draggable = false;
                            currentEntity.display.drag = null;
                            currentEntity.display._drag = null;
                            currentEntity.isHeavy = true;
                            currentEntity.show();
                            $(th.element).find('.signature_num').html(signatureNum.toString());
                            nextEntity(signatureNum);
                        }
                        $(th.element).find('[data-id=next-signature]').off("click")
                        $(th.element).find('[data-id=next-signature]').on("click", function () { onNextSignature(); })
                        $(th.element).find('[data-id=previous-signature]').off("click")
                        $(th.element).find('[data-id=previous-signature]').on("click", function () { onPreviousSignature(); })
                    }

                    reader.readAsArrayBuffer(pdf);
                } catch (e) {
                    throw e;
                }

            });
        } catch (e) {
            console.log(e);
        }
    }

    refreshSigneeCount(signeeCount: number) {
        //funkcija ki nastavi gumbe in popravi število podpisnikov
        let th = this;
        th.signeeCount = signeeCount;
        //currentStepSignature je korak na katerem je trenutno widget
        //če obstaja naslednji podpisnik pokaže gumb next
        if (signeeCount > th.currentStepSignature) {

            $(th.element).find('[data-id=next-signature]').show();
            $(th.element).find('.confirmrect').hide();
        } else {
            $(th.element).find('[data-id=next-signature]').hide();
            $(th.element).find('.confirmrect').show();
        }
        //če obstaja prejšnji podpisnik pokaže gumb previous
        if (th.currentStepSignature <= 1) {
            $(th.element).find('[data-id=previous-signature]').hide();
        } else {
            $(th.element).find('[data-id=previous-signature]').show();
        }
        //popravi label število podpisnikov
        if (signeeCount == null)
            $(th.element).find('.signature_count').html("1");
        else
            $(th.element).find('.signature_count').html(signeeCount.toString());

        //če je že completan ga resetiraj
        //če je manj podpisnikov kokr jih je blo že pozicioniranih resetiraj
        //če je manj podpisnikov kot prej ga resetiraj
        if ((signeeCount < th.currentStepSignature || signeeCount < th.currentMaxSignature)||th.completed) {
            th.initPdf(th.pdf, signeeCount);
        }

    }

    initPdfPreview(pdf: any) {
        let th = this;
        th.pdf = pdf;
        $(function () {
            var reader = new FileReader();
            reader.onload = function (e: any) {
                var arrayBuffer = e.target.result;
                var typedarray = new Uint8Array(arrayBuffer);
                var pdfjsLib = window['pdfjsLib'];

                pdfjsLib.GlobalWorkerOptions.workerSrc = "/js/pdf.worker.mjs";

                var pdfDoc = null,
                    pageNum = 1,
                    pageRendering = false,
                    pageNumPending = null,
                    scale = 1,
                    canvas = document.getElementsByClassName('the-canvas')[0] as HTMLCanvasElement,
                    ctx = canvas.getContext('2d');


                function renderPage(num) {       
                    try {
                        th._debugging("rendering page");
                        pageRendering = true;
                        pdfDoc.getPage(num).then(function (page) {
                            let self = th;
                            var unscaledViewport = page.getViewport({ scale: scale });
                            self._debugging(unscaledViewport);
                            while (unscaledViewport.width > window.innerWidth) {
                                scale -= 0.1;
                                th._debugging("scale: " + scale);
                                unscaledViewport = page.getViewport({ scale: scale });
                                th._debugging(unscaledViewport);
                            }
                            th._debugging("result:");
                            th._debugging(scale);
                            th.currentScale = scale;

                            //this.targetProxy.scale = scale;
                            var viewport = page.getViewport({ scale: scale });
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;

                            var renderContext = {
                                canvasContext: ctx,
                                viewport: viewport
                            };
                            var renderTask = page.render(renderContext);

                            renderTask.promise.then(function () {
                                pageRendering = false;

                                if (pageNumPending !== null) {
                                    renderPage(pageNumPending);
                                    pageNumPending = null;
                                }
                            });

                        }).catch(function (e) {
                            //$(th.element).find(".signature-modal").modal('hide');
                        });

                        $(th.element).find('.page_num').text(num);
                    } catch (e) {
                        throw e
                    }
                }

                function queueRenderPage(num) {
                    if (pageRendering) {
                        pageNumPending = num;
                    } else {
                        renderPage(num);
                    }
                }

                function onPrevPage() {
                    if (pageNum <= 1) {
                        return;
                    }
                    pageNum--;
                    queueRenderPage(pageNum);
                    th.pageResult = pageNum;
                }
                $(th.element).find('.prev').off("click");
                $(th.element).find('.prev').on("click", function () { onPrevPage(); })
                //next page
                function onNextPage() {
                    if (pageNum >= pdfDoc.numPages) {
                        return;
                    }
                    pageNum++;
                    queueRenderPage(pageNum);
                    th.pageResult = pageNum;
                }
                $(th.element).find('.next').off("click");
                $(th.element).find('.next').on("click", function () { onNextPage(); })
                //first page
                function onFirstPage() {
                    if (1 == pdfDoc.numPages) {
                        return;
                    }
                    pageNum = 1;
                    queueRenderPage(pageNum);
                    th.pageResult = pageNum;
                }
                $(th.element).find('.first').off("click");
                $(th.element).find('.first').on("click", function () { onFirstPage(); })
                //last page
                function onLastPage() {
                    if (pageNum >= pdfDoc.numPages) {
                        return;
                    }
                    pageNum = pdfDoc.numPages;
                    queueRenderPage(pageNum);
                    th.pageResult = pageNum;
                }
                $(th.element).find('.last').off("click");
                $(th.element).find('.last').on("click", function () { onLastPage(); })
                pdfjsLib.getDocument(typedarray).promise.then(function (pdfDoc_) {
                    pdfDoc = pdfDoc_;
                    $('.page_count').html(pdfDoc.numPages);
                    renderPage(pageNum);

                });
                function enablePinchZoom() {
                    let startX = 0, startY = 0;
                    let initialPinchDistance = 0;
                    let pinchScale = 1;
                    const viewer = document.getElementsByClassName("the-canvas")[0];
                    const container = document.getElementsByClassName("canvas-wrapper")[0];
                    const reset = () => { startX = startY = initialPinchDistance = 0; pinchScale = 1; };
                    // Prevent native iOS page zoom
                    //document.addEventListener("touchmove", (e) => { if (e.scale !== 1) { e.preventDefault(); } }, { passive: false });
                    $(viewer).on("touchstart", (e) => {
                        th._debugging("touchstart");
                        if (e.touches.length > 1) {
                            startX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
                            startY = (e.touches[0].pageY + e.touches[1].pageY) / 2;
                            initialPinchDistance = Math.hypot((e.touches[1].pageX - e.touches[0].pageX), (e.touches[1].pageY - e.touches[0].pageY));
                        } else {
                            initialPinchDistance = 0;
                        }
                    });
                    $(viewer).bind("touchmove", (e) => {
                        e.preventDefault();
                        th._debugging("touchmove");
                        th._debugging(e.touches.length)
                        th._debugging(initialPinchDistance);
                        if (initialPinchDistance <= 0 || e.touches.length < 2) { return; }
                        if (th.currentScale !== 1) { e.preventDefault(); }
                        const pinchDistance = Math.hypot((e.touches[1].pageX - e.touches[0].pageX), (e.touches[1].pageY - e.touches[0].pageY));
                        const originX = startX + container.scrollLeft;
                        const originY = startY + container.scrollTop;
                        pinchScale = pinchDistance / initialPinchDistance;
                        scale = 1- pinchScale;
                        renderPage(pageNum);
                    });
                    $(viewer).on("touchend", (e) => {
                        th._debugging("touchend");
                        if (initialPinchDistance <= 0) { return; }
                        (viewer as HTMLCanvasElement).style.transform = `none`;
                        (viewer as HTMLCanvasElement).style.transformOrigin = `unset`;
                        th.currentScale *= pinchScale;
                        const rect = container.getBoundingClientRect();
                        const dx = startX - rect.left;
                        const dy = startY - rect.top;
                        container.scrollLeft += dx * (pinchScale - 1);
                        container.scrollTop += dy * (pinchScale - 1);
                        reset();
                    });
                }

            }
            reader.readAsArrayBuffer(pdf);

        });
    }
    sendResults(id: any) {
        return new Promise((resolve) =>
            $.ajax({
                type: 'POST',
                url: "set-signature-position",
                data: { "rect": this.rectResultElement, "page": this.pageResult, "idZahtevka": id },
                contentType: 'application/x-www-form-urlencoded',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            })
        );
    }
    getResults() {
        let th = this;
        let result: Array<object> = [];
        this.resultEntities.forEach(function (e, i) {
            result.push({ "left": e.data.pos.x, "top": e.data.pos.y, "page": e.page });
        });
        return result;
        //return { "left": this.rectResultElement.left, "top": this.rectResultElement.top, "width": this.rectResultElement.width, "height": this.rectResultElement.height, "page": this.pageResult }
    }

    results() {
        this._debugging("confirm");
        return { rect: this.rectResultElement.top, page: this.pageResult };
    }

    
    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        $("#loader").show();
    }
    _hideLoader() {
        $("#loader").hide();
    }       
}

window.onerror = function (err) {
    console.log(err); // logs all errors
}